import { css } from '@emotion/css';
import { Color, Font } from 'src/styles';

export const error = css`
  color: ${Color.Red6} !important;
  ${Font.md}
`;
